<template>
  <div class="workList">
    <div class="header">
      <div class="container">
        <img class="logo" src="/img/ghltjLogo.png" alt="">
        <template v-if="gIsLogin()">
          <router-link class="nav" to="/personal_info">完善信息</router-link>
          <span class="nav" @click="logOut">退出登录</span>
        </template>
        <template v-else>
          <router-link class="nav" :to="{path:'/login?fromUrl=/ddf_vote?p_type=' + prizeId}">登录</router-link>
          <router-link class="nav" :to="{path:'/register?fromUrl=/ddf_vote?p_type=' + prizeId}">注册</router-link>
        </template>  
      </div>
      
    </div>
    <div class="container">
      <p v-if="false" class="type">参评类型</p>
      <div v-if="false">
        <span class="typeItem" 
          :class="{'typeItemActive': prizeId==a.id}" 
          v-for="a in prizeList" 
          :key="a.id" 
          @click="changeType(a.id)">{{a.shortName}}</span>
      </div>
      <p class="voteTitle">第十六届（2020）光华龙腾奖 · {{getPrizeText}}公众投票</p>
      <p class="note">每人有一次投票的权利，选出您心目中的“{{getPrizeText}}”</p>
      <p class="type">总人数（{{total}}）</p>
      <Table class="voteTable" stripe :columns="columns" :data="list" :loading="loading" @on-select="select" @on-select-cancel="cancel"></Table>
      <div class="btnWrap">
        <Button class="defaultBtn" @click="vote">{{userVote[prizeId]?'已投票':'投票'}}</Button>
      </div>
      <div class="jishu">
        龙腾之星提供技术支持
      </div>
    </div>
    <div class="footer">
      <div class="container">
        <Row :gutter="30">
          <Col :lg="9" :md="9" :sm="24" :xs="24">
            <p>联系我们</p>
            <p>光华龙腾奖办公室</p>
            <p>地址：北京市大兴区金苑路26号院3号楼三层</p>
            <p>电话：15810007797</p>
            <p>传真：010-83681552</p>
            <p>邮箱：601@ddfddf.org</p>
            <p>
              <img class="code" src="/img/ghltjCode.jpg" alt="">
            </p>
          </Col>
          <Col :lg="15" :md="15" :sm="24" :xs="24">
            <p>组织机构</p>
            <p>主办：北京光华设计发展基金会</p>
            <p>战略合作媒体：新华社主管《中国名牌》杂志</p>
            <p>合作单位：中国创新设计产业战略联盟、工业和信息化部工业文化发展中心、中国机械工程学会、中国建筑装饰协会、中国勘察设计协会、中国室内装饰协会、中国工业设计协会、中国流行色协会、中国服装设计师协会、全国工商联家具装饰业商会、北京设计学会、广东省工业设计协会、浙江省工业设计协会、上海工业设计协会、深圳市工业设计协会、深圳市工业设计产业协会、清华大学美术学院、中央美术学院、浙江大学、中国美术学院、湖南大学等</p>
            <p>专业媒体：《设计》杂志、中国工业设计报、《视觉中国》、《视觉同盟》、《创意世界》、时机科技等</p>
          </Col>
        </Row>
      </div>
    </div>
  </div>
</template>

<script>
import Service from "@/api/ddfVote";
export default {
  data() {
    return {
      selectList: [],
      userVote: {},

      loading: false,
      total: 0,
      list: [],
      columns: [
        {
          title: "",
          key: "sel",
          type: "selection",
          width: 40,
          fixed: "left"
        },
        {
          title: "姓名",
          key: "name",
          width: 135,
          fixed: "left",
          render: (h, { row }) => {
            let img = h("img", {
                style: {
                  width: "50px",
                  height: "50px",
                  verticalAlign: "middle",
                  borderRadius: "50px",
                  marginRight: "8px",
                  marginTop: "8px",
                  marginBottom: "8px"
                },
                attrs: {
                  src: this.getImageUrlDdf(row.avatar)
                }
              }),
              name = h("span", {}, row.name);
            return h("div", [img, name]);
          }
        },
        {
          title: "性别",
          key: "sex",
          width: 50,
          render: (h, { row }) => {
            return h("div", {}, row.participantExt.sex || "-");
          }
        },
        {
          title: "所在单位",
          key: "company",
          minWidth: 250,
          render: (h, { row }) => {
            return h("div", {}, row.company || "-");
          }
        },
        {
          title: "职务",
          key: "position",
          minWidth: 160,
          render: (h, { row }) => {
            return h("div", {}, row.participantExt.position || "-");
          }
        },
        // {
        //   title: "参评类型",
        //   key: "pShortName",
        //   width: 120,
        //   render: (h, { row }) => {
        //     return h("div", {}, row.pShortName || "-");
        //   }
        // },
        {
          title: "推报单位",
          key: "push",
          minWidth: 180,
          render: (h, { row }) => {
            return h("div", {}, row.participantExt.push || "-");
          }
        },
        // {
        //   title: "生日",
        //   key: "birth",
        //   width: 120,
        //   render: (h, { row }) => {
        //     return h("div", {}, row.participantExt.birth || "-");
        //   }
        // },
        // {
        //   title: "所属地域",
        //   key: "residence",
        //   width: 150,
        //   render: (h, { row }) => {
        //     return h(
        //       "div",
        //       {},
        //       row.participantExt.residencePName +
        //         " " +
        //         row.participantExt.residenceName || "-"
        //     );
        //   }
        // },
        // {
        //   title: "行业领域/方向",
        //   key: "industry",
        //   width: 120,
        //   render: (h, { row }) => {
        //     return h("div", {}, row.participantExt.industry || "-");
        //   }
        // },
        // {
        //   title: "职业类型",
        //   key: "career",
        //   width: 120,
        //   render: (h, { row }) => {
        //     return h("div", {}, row.career || "-");
        //   }
        // }
      ],

      prizeId: null,
      prizeList: []
    };
  },
  mounted() {
    document.title = "公众投票 - 光华龙腾奖（2020）中国设计贡献奖暨光华龙腾奖（2020）"
    this.prizeId = this.$route.query.p_type || 6;
    this.getPrizeList();
    if (this.gIsLogin()) {
      this.getUserDdfVote();
    }
  },
  computed: {
    getPrizeText() {
      for (let i = 0, l = this.prizeList.length; i < l; i++) {
        if (this.prizeId == this.prizeList[i].id) {
          return this.prizeList[i].shortName;
        }
      }
      return "-";
    }
  },
  methods: {
    // 退出登录
    logOut() {
      this.$store.commit("setToken", "");
      this.$store.commit("setUserInfo", {});
      window.localStorage.removeItem("login_time");
      this.$router.go(0);
    },
    // 获取当前用户参与投票信息
    getUserDdfVote() {
      let userId = this.$store.getters.userInfo.id;
      Service.getUserDdfVote({ "userId.eq": userId })
        .then(res => {
          if (res.errorNo == 0) {
            let data = res.data;
            for (let i = 0, l = data.length; i < l; i++) {
              let p = data[i].prizeId;
              if (!this.userVote[p]) {
                this.userVote[p] = true;
              }
            }
          } else {
            this.$Message.error(res.errorMessage);
          }
        })
        .catch(() => {
          this.$Message.error("连接服务器失败，请稍后再试");
        });
    },
    // 投票
    vote() {
      if (this.gIsLogin()) {
        if (this.userVote[this.prizeId]) {
          this.$Message.info("您已经参与过投票，不能重复参与。");
          return;
        }
        if (this.selectList.length == 0) {
          this.$Message.info("请选择投票人员！");
          return;
        }
        let condition = {};
        condition.prizeId = this.prizeId;
        condition.voteIds = this.selectList;
        Service.voteDdf(condition)
          .then(res => {
            if (res.errorNo == 0) {
              this.$Message.success("投票成功！");
              this.selectList = [];
              for (let i = 0, l = this.list.length; i < l; i++) {
                this.list[i]._disabled = false;
                this.list[i]._checked = false;
              }
              this.userVote[this.prizeId] = true;
            } else {
              this.$Message.error(res.errorMessage);
            }
          })
          .catch(() => {
            this.$Message.error("连接服务器失败，请稍后再试");
          });
      } else {
        this.$Modal.info({
          title: "提示",
          content: "登录后才能参与投票",
          okText: "去登录",
          onOk: () => {
            this.$router.push("/login?fromUrl=/ddf_vote");
          }
        });
      }
    },
    // 选中某一项
    select(selection) {
      let s = selection.length,
        list = [];
      for (let i = 0; i < s; i++) {
        list.push(selection[i].id);
      }
      this.selectList = list;
      if (s == 10) {
        for (let i = 0, l = this.list.length; i < l; i++) {
          if (this.selectList.indexOf(this.list[i].id) != -1) {
            this.list[i]._checked = true;
          }
          if (this.selectList.indexOf(this.list[i].id) == -1) {
            this.list[i]._disabled = true;
            this.list[i]._checked = false;
          }
        }
      }
    },
    // 取消某一项
    cancel(selection) {
      let s = selection.length,
        list = [];
      for (let i = 0; i < s; i++) {
        list.push(selection[i].id);
      }
      this.selectList = list;

      if (selection.length == 9) {
        for (let i = 0, l = this.list.length; i < l; i++) {
          if (this.selectList.indexOf(this.list[i].id) != -1) {
            this.list[i]._checked = true;
          }
          if (this.selectList.indexOf(this.list[i].id) == -1) {
            this.list[i]._disabled = false;
            this.list[i]._checked = false;
          }
        }
      }
    },
    // 获取参评类型
    getPrizeList() {
      this.loading = true;
      Service.getDDFPrize()
        .then(res => {
          if (res.errorNo == 0) {
            this.prizeList = res.data;
            // this.prizeId = this.prizeList[0].id;
            this.getList();
          } else {
            this.$Message.error(res.errorMessage);
          }
        })
        .catch(() => {
          this.$Message.error("连接服务器失败，请稍后再试");
        });
    },
    // 切换参赛类型
    changeType(id) {
      if (this.prizeId == id) {
        return;
      }
      this.prizeId = id;
      this.getList();
    },
    // 获取人员列表
    getList() {
      let condition = {
        page: 0,
        size: 30,
        "status.eq": 2,
        "pType.eq": this.prizeId
      };
      this.loading = true;
      Service.getDDFRegistration(condition)
        .then(res => {
          if (res.errorNo == 0) {
            this.list = res.data;
            for (let i = 0, l = this.list.length; i < l; i++) {
              this.$set(this.list[i], "_checked", false);
              this.$set(this.list[i], "_disabled", false);
            }
            this.total = res.totalSize;
          } else {
            this.$Message.error(res.errorMessage);
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
          this.$Message.error("连接服务器失败，请稍后再试");
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.workList {
  min-height: 100%;
  padding-top: 60px;
  .header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 50px;
    // background: url(/img/navBg.jpg) no-repeat center #ffffff;
    background: rgba(0, 0, 0, 0.85);
    background-size: cover;
    text-align: right;
    z-index: 999;

    .logo {
      float: left;
      width: 70px;
      margin-top: 4px;
    }

    .nav {
      line-height: 50px;
      color: #fff;
      padding: 0 10px;
      margin-left: 10px;
      cursor: pointer;
    }
  }
  .type {
    padding: 10px 0;
  }
  .note {
    padding: 10px 0;
    text-align: center;
  }
  .typeItem {
    display: inline-block;
    padding: 2px 10px 3px;
    margin: 0 10px 10px 0;
    border: 1px solid #7f7f7f;
    border-radius: 5px;
    cursor: pointer;
  }
  .typeItemActive {
    cursor: default;
    background: linear-gradient(to right, #5de2c6, #46a2e1);
    color: #fff;
    border-color: #5de2c6;
  }
  .voteTitle {
    text-align: center;
    padding: 20px 15px;
    font-size: 20px;
    color: #D30830;
  }
  .btnWrap {
    padding: 30px 0;
    text-align: center;
  }
  .jishu{
    text-align: center;
    padding: 0 0 20px;
    font-size: 12px;
  }
  .footer {
    padding: 50px 0;
    line-height: 1.8em;
    background: #ac1a2c;
    color: #f2f2f2;

    .code {
      width: 50%;
      max-width: 110px;
      padding: 10px 0;
    }
  }
}
</style>
